export default __webpack_public_path__ + "static/media/logo.3f0b9c1d.png";